// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { AbstractModuleUi } from '../_abstract/ui'

import { LiveFeedModule } from './LiveFeed.contracts'

/**
 * Component capable of rendering the `LiveFeedModule`'s contents.
 *
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
@Component({ name: 'LiveFeedModuleUi' })
export class LiveFeedModuleUi extends AbstractModuleUi<LiveFeedModule> {}
